import React from "react";
import { useScrollProgress } from "../../hooks/useScrollProgress";

const SECTIONS = [
  { id: "origin", label: "Origin" },
  { id: "philosophy", label: "Philosophy" },
  { id: "shift", label: "The Shift" },
  { id: "essence", label: "Essence" },
  { id: "begin", label: "Begin" },
];

export function ScrollNav() {
  const progress = useScrollProgress();
  const activeIndex = Math.min(Math.floor(progress * SECTIONS.length), SECTIONS.length - 1);

  return (
    <nav
      className="fixed right-6 top-1/2 -translate-y-1/2 z-[100] flex flex-col items-end gap-4"
      style={{ opacity: progress > 0.02 ? 1 : 0, transition: "opacity 0.5s ease" }}
    >
      {SECTIONS.map((section, i) => {
        const isActive = i === activeIndex;
        return (
          <div key={section.id} className="flex items-center gap-3">
            <span
              className="text-[10px] tracking-[0.2em] uppercase font-light transition-all duration-300"
              style={{
                color: isActive ? "oklch(0.35 0.05 280)" : "oklch(0.6 0.03 280 / 0.4)",
                opacity: isActive ? 1 : 0.5,
                transform: isActive ? "translateX(0)" : "translateX(5px)",
              }}
            >
              {section.label}
            </span>
            <div
              className="rounded-full transition-all duration-500"
              style={{
                width: isActive ? 10 : 4,
                height: isActive ? 10 : 4,
                background: isActive
                  ? "linear-gradient(135deg, oklch(0.55 0.08 280), oklch(0.6 0.06 160))"
                  : "oklch(0.75 0.03 280 / 0.4)",
                boxShadow: isActive ? "0 0 12px oklch(0.6 0.1 280 / 0.3)" : "none",
              }}
            />
          </div>
        );
      })}
    </nav>
  );
}
